import { useQuery } from '@tanstack/react-query';
import { CompanyDocument } from '../types';

export const useCompanyDocuments = () => {
  const { data, isLoading, refetch, error, isError } = useQuery<CompanyDocument[]>({
    queryKey: ['company-documents'],
  });

  return {
    documents: data ?? [],
    isLoading,
    refetch,
    error,
    isError,
  };
};
